import React from "react";
import { Checkmark } from "../images/icons";
import { DumeleRound, HivosRound } from "../images/logos";
import whmRound from "../images/whm-round.png";
import samba from "../images/samba-yonga.png";
import mulenga from "../images/mulenga-kapwepwe.png";
import victoria from "../images/victoria-phiri.png";
import dumele from "../images/dumele-logo-2.png";
import whm from "../images/whm-logo-2.png";
import hivos from "../images/hivos-logo-2.png";
import Donate from "../components/Donate";
import Subscribe from "../components/Subscribe";

const About = () => {
  return (
    <div>
      <div className="about-hero flex items-center justify-center h-[320px] text-white">
        <h1>ABOUT US</h1>
      </div>
      <div className="px-24 py-24 md:px-0 flex flex-col items-center space-y-32 md:space-y-0">
        <h1 className="text-center w-3/5 md:w-full md:text-3xl md:px-2 md:mb-20">
          We are Preserving & Restoring African Indigenous Knowledge & Living
          Histories Focused on Women
        </h1>
        <div className="flex">
          <div className="flex-1 md:hidden">
            <div>
              <img src={dumele} alt="" className="w-[321px]" />
            </div>
          </div>
          <div className="w-3/5 md:w-full bg-apricot/20 shadow-lg rounded-lg p-8 space-y-4">
            <div className="flex-1 md-min:hidden w-1/2 mb-6">
              <div>
                <img src={dumele} alt="" className="w-[321px]" />
              </div>
            </div>
            <p className="font-semibold">
              Formed by artist Mulenga Kapwepwe and journalist Samba Yonga, the
              Women’s History Museum of Zambia aims to salvage and elevate
              women’s histories and their sources. The main mission is to
              popularize, demystify, and decolonize women’s indigenous knowledge
              by performing the following:
            </p>
            <ul className="space-y-3">
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">
                    Research, preserve, and restore African indegenous knowledge
                    and living histories focused on women.
                  </div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">
                    Collect, archive, and exhibit women’s stories, crafts,
                    artifacts and geopolitical contributions.
                  </div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">
                    Make use of sensory engagement to increase understanding of
                    how indigenous knowledge is transferred.
                  </div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">
                    Incubate indegenous skills and products.
                  </div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">
                    Create a validation system for indegenous knowledge.
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex">
          <div className="w-3/5 md:w-full bg-[#F2F2F2]/90 shadow-lg rounded-lg p-8 space-y-8">
            <div className="flex-1 md-min:hidden w-1/2 mb-6">
              <div>
                <img src={whm} alt="" className="w-[321px] md:w-full" />
              </div>
            </div>
            <p className="font-semibold">
              Dumele is designed to integrate technological innovation into the
              preservation of African artisanal products and practices. born.
            </p>
            <p className="font-semibold">
              We are a group of engineers, developers, designers, artisans and
              strategists, we specialize in the conceptualization, design, and
              embedding of technological software and hardware, to create
              multisensory experiences with indigenously-inspired goods.
            </p>
            <p className="font-semibold">
              We believe in a world where machines simply cannot compete with
              human ingenuity but rather enable it. We believe in a world where
              fewer people are left behind as their artisanal skills are
              utilized to craft modernity. And we believe in a world where
              information and stories are preserved to strengthen the cultures
              into which we are born.
            </p>
          </div>
          <div className="flex-1 flex justify-end md:hidden">
            <div>
              <img src={whm} alt="" className="w-[321px]" />
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="flex-1 md:hidden">
            <div>
              <img src={hivos} alt="" className="w-[245px]" />
            </div>
          </div>
          <div className="w-3/5 md:w-full bg-apricot/20 shadow-lg rounded-lg p-8 space-y-4">
            <div className="flex-1 md-min:hidden w-2/5 mb-6">
              <div>
                <img src={hivos} alt="" className="w-[321px]" />
              </div>
            </div>
            <p className="font-semibold">
              Hivos was founded in 1968, and works for a world where people can
              realize their full potential, unleashing their ingenuity and
              creativity to build fair, just and life-sustaining societies for
              themselves and generations to come. Our mission is to amplify and
              connect voices that promote social and environmental justice and
              challenge power imbalances. Our core values are:
            </p>
            <ul className="space-y-3">
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">Freedom & Dignity</div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">Responsible Citizenship</div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">Self-determination & diversity</div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">Equality & justice</div>
                </div>
              </li>
              <li>
                <div className="flex space-x-3">
                  <div className="w-7 pt-1">
                    <Checkmark />
                  </div>
                  <div className="flex-1">
                    Sustainable use of our planet’s resources
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="our-team py-40 px-48 md:px-10 flex flex-col items-center space-y-20">
        <h1 className="flex md:text-2xl">
          OUR <span className="h1-span text-secondary ml-1">TEAM</span>
        </h1>
        <div className="flex items-center justify-center">
          <div className="flex items-center">
            <div>
              <DumeleRound />
            </div>
            <div>
              <img src={whmRound} alt="" className="h-[99px]" />
            </div>
            <div>
              <HivosRound />
            </div>
          </div>
        </div>
        <div className="flex flex-col space-y-32">
          <div className="flex md:flex-col self-start md:self-center items-center space-x-10 md:space-x-0 md:space-y-8 w-4/6 md:w-full">
            <div className="h-[434px] bg-white flex flex-col justify-between">
              <div className="w-[312px] h-4/5 rounded-bl-lg rounded-br-lg">
                <img
                  src={samba}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="py-4 px-6 text-lg font-semibold flex flex-1 items-center justify-center">
                Samba Yonga
              </div>
            </div>
            <div>
              <p className="font-medium md:font-normal md:text-sm md:text-center">
                Samba Yonga is a Zambian journalist and media consultant. She is
                the Founder of Ku-Atenga Media, a media consultancy firm and was
                named one of Destiny’s “Power of 40” most influential women in
                Africa in 2017 and one of Quartz Africa’s 2019 Innovators. She
                is a TEDx speaker on the topic of the Blueprint for an African
                Superhero Curriculum.
              </p>
            </div>
          </div>
          <div className="flex md:flex-col self-center md:self-center items-center space-x-10 md:space-x-0 md:space-y-8 w-4/6 md:w-full">
            <div className="h-[434px] w-[312px] bg-white flex flex-col content-between">
              <div className="w-[312px] h-4/5 rounded-bl-lg rounded-br-lg">
                <img
                  src={mulenga}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="py-4 px-6 text-lg font-semibold flex flex-1 items-center justify-center">
                Mulenga Kapwepwe
              </div>
            </div>
            <div>
              <p className="font-medium md:font-normal md:text-sm md:text-center">
                Mulenga Kapwepwe is a Zambian artist and author. She is the
                chairperson of the National Arts Council, the founder of the
                Lusaka Youth Orchestra, and is known for her work as a playright
                and arts activist, building libriaries to help young Zambian
                children educate themselves. She has been featured as a TEDx
                speaker and patron of the arts by CNN.
              </p>
            </div>
          </div>
          <div className="flex md:flex-col self-end md:self-center items-center space-x-10 md:space-x-0 md:space-y-8 w-4/6 md:w-full">
            <div className="h-[434px] w-[312px] bg-white flex flex-col content-between">
              <div className="w-[312px] h-4/5 rounded-bl-lg rounded-br-lg">
                <img
                  src={victoria}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="py-4 px-6 text-lg font-semibold flex flex-1 items-center justify-center">
                Victoria Phiri
              </div>
            </div>
            <div>
              <p className="font-medium md:font-normal md:text-sm md:text-center">
                Victoria Phiri Chitungu is a cultural historian and Senior
                Curator of Choma Museum and Crafts Centre. She holds an M.A in
                Indigenous Studies and has worked for the National Museums Board
                of Zambia for over 20 years, as a researcher and director. She
                specializes in Zambian cultures and has done extensive field
                research work across the country. The findings have contributed
                to permanent exhibitions of the National Museums of Zambia and
                have been published in international publications.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Donate />
      <Subscribe />
    </div>
  );
};

export default About;
